import React, { useEffect } from "react";
import "./PnLFloorplans.scss";
import { useSelector } from "react-redux";
import PnLFloorplansLot from "../PnLFloorplansLot/PnLFloorplansLot";
import { useScrollBoost } from "react-scrollbooster";
import Cover from "../Cover/Cover";

function PnLFloorplans(props) {
    var scrollPos = useSelector(state => state.floorplan.pnlFloorplanScrollPosition);
    var lots = useSelector(state => state.floorplan.activeFloorplans);
    var icons = useSelector(state => state.content.pages.floorplans);
    var isTouchScreen = useSelector(state => state.utilities.isTouchScreen);

    /*
    var [viewport] = useScrollBoost({
        direction: 'all',
        friction: 0.05,
        scrollMode: 'native'
    });
    */

    /*
    useEffect(() => {
        window.scrollTo(0, scrollPos);
    }, []);
    */
    
    function displayListContainer() {
        if(props.displayElevation) {
            return (
                <div className="list-container">
                    {lots.map((lot, lkey) => 
                        <React.Fragment>
                        {lot.elevation.map((elv, ekey) => 
                            <PnLFloorplansLot
                                lot={lot}
                                elv={elv}
                                lotIndex={lkey}
                                elvIndex={ekey}
                                icons={icons}
                            />
                        )}
                        </React.Fragment>
                    )}
                </div>
            )   
        }
        else {
            return (
                <div className="list-container">
                    {lots.map((lot, lkey) => 
                        <PnLFloorplansLot
                            lot={lot}
                            elv={lot.elevation[0]}
                            lotIndex={lkey}
                            elvIndex={0}
                            icons={icons}
                        />
                    )}
                </div>
            )
        }
    }

    if(typeof lots !== 'undefined' && typeof icons !== 'undefined') {
        icons = icons.floorplan_product_icons;

        return (
            <div
                //ref={viewport}
                className="pnl-floorplans-viewport"
            >
                <div className={`PnLFloorplans${isTouchScreen ? " touchscreen" : ""}`}>
                    <Cover fadeImmediately />
                    <h1 className="list-heading">All Lots</h1>

                    {displayListContainer()}
                </div>
            </div>
        )
    }
    else {
        return (
            <div></div>
        )
    }
}

export default PnLFloorplans;